import {http} from '@/http'
import { Util } from "wize-admin"

export default {
  list(data, params) {
    return http.post('/payroll-batch/list', data, {params})
  },
  changeStatus(id, status) {
    return http.put(`/payroll-batch/${id}/status`, null, {params: {status}})
  },
  uploadBatch(data){
    const formData = Util.getFormData(data);
    return http.post('/payroll-batch', formData, {headers: { "Content-Type": "multipart/form-data" },})
  },
  download(data) {
    return http.get("/payroll-batch/template/xlsx", data, { responseType: "blob" });
  }
}
